// extracted by mini-css-extract-plugin
export default {"overlay":"Tv-z","bodyOpen":"Uv-z","content":"Vv-z","header":"Wv-z","close":"Xv-z","closeNoHeading":"Yv-z"};